<template>
  <div class="LoginVue-wrap">
    <div class="LoginVue-box">
        <h1>登录</h1>
        <div class="input-wrap">
            <span>登录账号</span>
            <div class="input-box">
                <i class="iconfont icon-yonghuming"></i>
                <input type="text" v-model="username" placeholder="请输入邮箱" @keyup.enter="goLogin"/>
            </div>
        </div>
        <div class="input-wrap">
            <span>登录密码</span>
            <div  class="input-box">
                <i class="iconfont icon-mima"></i>
                <input type="password" v-model="password" placeholder="请输入密码" @keyup.enter="goLogin"/>
            </div>
        </div> 
        <div class="input-wrap">
            <div class="input-box-2">
                <input type="text" v-model="code" placeholder="请输入验证码" @keyup.enter="goLogin"/>
                <img :src="captcha" :alt="captcha" @click="getCaptcha">
            </div>
        </div>
        
        <div class="login-button" @click="goLogin">
            <span>登录</span>
        </div>
        <span class="register-button" @click="openRegister">注册账号</span>
        <span class="register-button" @click="openResetPassword">忘记密码</span>
        <div class="input-wrap-2">
            <!-- <input type="checkbox" id="successFlag" v-model="successFlag" name="successFlag" /> -->
            <label for="successFlag">登录视为您已阅读并同意</label>
            <span class="service-message" v-for="(item,index) in serviceList" :key="index" @click="showMessage(item)">{{ item.title }}{{ index === (serviceList.length-1)?'':'、' }}</span>
        </div>
    </div>
  </div>
</template>

<script>
import api from '@/api/login'
import CryptoJS from 'crypto-js'
export default {
    name: "LoginVue",
    data() {
        return {
            username: '',
            password: '',
            captcha: '',
            code: '',
            uuid: '',
            // successFlag: false
        }
    },
    props:{
        serviceList: {
            type: Array,
            defaults() {
                return []
            },
        }
    },
    methods: {
        showMessage(item) {
            this.$emit('openMessageBoxWrap',item)
        },
        openRegister() {
            this.$emit('openRegister')
        },
        openResetPassword() {
            this.$emit('restPassword')
        },
        cryptoJSPassword(password) { 
            const SECRET_KEY = "0123456789abcdef0123456789abcdef"; // 32字节(256位)密钥
            const IV = "abcdefghijklmnop"; // 16字节IV
            const key = CryptoJS.enc.Utf8.parse(SECRET_KEY);
            const iv = CryptoJS.enc.Utf8.parse(IV);
            const encrypted = CryptoJS.AES.encrypt(
                password,
                key,
                { 
                    iv: iv,
                    mode: CryptoJS.mode.CBC,
                    padding: CryptoJS.pad.Pkcs7
                }
            );
            return encrypted.toString()
        },
        goLogin() {
            if(!this.username || !this.password) {
                this.$message({
                    message: '账号或密码不能为空',
                    type: 'warning'
                })
                return;
            }
            if(!this.code) {
                this.$message({
                    message: '验证码不能为空',
                    type: 'warning'
                })
                
                return;
            }
            // if(!this.successFlag) {
            //     this.$message({
            //         message: '请阅读并同意服务条款',
            //         type: 'warning'
            //     })
            //     return;
            // }
            api.goLogin({
                email: this.username,
                password: this.cryptoJSPassword(this.password),
                captcha: this.code,
                uuid: this.uuid
            }).then(res=> {
                if(res.code ===0) {
                    sessionStorage.setItem("login",true);
                    sessionStorage.setItem("name",res.data.username);
                    sessionStorage.setItem("token",res.data.token);
                    this.$message({
                        message: '登录成功',
                        type: 'success'
                    })
                    this.$emit("loginInto",res.data)
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error'
                    })
                    this.getCaptcha()
                }
            })
        },
        getCaptcha() {
            this.uuid = new Date().getTime();
            api.getLoginCaptcha(this.uuid).then(res=> {
                this.captcha = URL.createObjectURL(res);
            })
        }
    },
    created() {
        this.getCaptcha()
    }
}
</script>

<style lang="scss" scoped>
.LoginVue-wrap {
    position: fixed;
    top: 50%;
    right: 30px;
    transform: translateY(-50%);
    width: 500px;
    padding: 70px 45px 35px;
    background: #fff;
    box-shadow: 0px 2px 6px 0px rgba(0,0,0,0.4);
    border-radius: 8px;
    color: rgba(16,16,16,1);
    font-family: 'Roboto';
    z-index: 9999;
    max-height: 95%;
    overflow-y: auto;
    .LoginVue-box {

        h1 {
            margin-bottom: 50px;
        }
        .input-wrap {
            margin-top: 20px;

            span {
                font-size: 16px;
                color: #999;
            }

            .input-box {
                margin-top: 10px;
                position: relative;

                input {
                    width: 100%;
                    font-size: 16px;
                    padding: 10px 40px;
                    border: none;
                    outline: none;
                    background: #f5f5f5;
                    border-radius: 5px;
                }

                i {
                    color: #101010;
                    position: absolute;
                    top: 50%;
                    left: 10px;
                    transform: translateY(-50%);
                }
            }

            .input-box-2 {
                margin-top: 40px;
                display: flex;
                align-items: center;
                img {
                    cursor: pointer;
                }
                span {
                    display: inline-block;
                    flex: 2;
                    text-align: center;
                    &:first-of-type {
                        flex: 1;
                    }
                    &:last-of-type {
                        color:#124FFF;
                        cursor: pointer;
                    }
                }
                input {
                    font-size: 16px;
                    padding: 10px 40px;
                    border: none;
                    outline: none;
                    background: #f5f5f5;
                    border-radius: 5px;
                    flex: 2;
                    max-width: 200px;
                }
            }
            
        }

        .login-button {
            margin-top: 50px;
            
            span {
                display: block;
                padding: 15px 0;
                text-align: center;
                color: #fff;
                background: #00a8ff;
                border-radius: 5px;
                cursor: pointer;
            }
        }

        .register-button {
            display: inline-block;
            margin-right: 30px;
            margin-top: 30px;
            color: #00a8ff;
            cursor: pointer;
            &:hover {
                text-decoration: underline;
            }
        }

        .service-message {
            display: inline-block;
            color: #999;
            cursor: pointer;
            &:hover {
                text-decoration: underline;
            }
        }
    }
}
.input-wrap-2 {
    text-align: center;
    margin-top: 20px;
    color: #999;
    label {
        margin-right: 5px;
    }
}
.input-wrap-2 input {
    vertical-align: middle;
}
</style>